import React from 'react';
import './ShimmerUI.css'; // Import the CSS file for shimmer effect

const Shimmer = () => {
  return (
    <div>
    <div className="shimmer-container">
      <div className="shimmer-title" />
      <div className="shimmer-subtitle" />
      <div className="shimmer-today-rates-title" />
      <div className="shimmer-today-rates-subtitle" />
      <div className="shimmer-content-boxes">
        <div className="shimmer-box" />
        <div className="shimmer-box" />
      </div>
      <div className="shimmer-buttons">
        <div className="shimmer-button" />
        <div className="shimmer-button" />
        <div className="shimmer-button" />
      </div>
      <div className="shimmer-paragraph" />
    </div>
    <div className="shimmer-container-banner">
      <div className="shimmer-box-banner"></div>
      <div className="shimmer-box-banner banner-box"></div>
      <div className="shimmer-box-banner banner-box"></div>
    </div>
    </div>
  );
};

export default Shimmer;
